export * from './offene-gutachten.service';
export * from './offene-gutachten.service.module';